export const commonParams = {
  app_type: 'h5',
  version: '0',
  lang: 'zh-cn',
  timestamp: new Date().getTime()
}

let headers = {}

const token = sessionStorage.getItem('token')

if (token) {
  headers.token = token
} else {
  if (process.env.NODE_ENV !== 'production') {
    console.log('+++++++++++++++开发环境')
    // admin
    // headers.token = '860ce2da-2cb6-4d02-8428-53370ea7fa24'
    // 日华
    // headers.token = '7f840f69-06d8-4381-9f40-fe29d2633a5b'
    // 陈宽
    // headers.token = 'cf2fd838-ba01-4e2c-bc2e-aa6138bfe6f0'
    // niansi
    // headers.token = 'fb528e1b-4067-489a-abe7-9e0d0ad70bb9'
    // xiaogao
    // headers.token = 'e33f9af6-1c42-462f-ae0f-5d25a1c52d36'
    // headers.token = 'e5f89733-07e3-4f99-8a03-3fba8e9e2bfb'
    headers.token = 'b71118de-4b28-44d1-ba26-0919061fa790'
  } else {
    console.log('+++++++++++++++生成环境')
  }
}

export { headers }

export const baseUrl = '/api/v1'

export const RES_OK = 1

export const PAGE_SIZE = 10



// WEBPACK FOOTER //
// ./src/api/config.js